// import { useState, useEffect, Fragment } from "react";
// import Video from "../../../assets/videoQZ.mp4";
// import RequestDemo from "../../RequestDemo/RequestDemo";
// // Import icons for features
// import { FaMoneyBillWave, FaBitcoin, FaCreditCard, FaGlobeAmericas, FaExchangeAlt } from "react-icons/fa";
// // Import API functions
// import * as api from "../../../api"

// // Add CSS for flip animation
// const flipAnimationStyle = `
//   @keyframes flip {
//     0% { transform: rotateX(0); }
//     100% { transform: rotateX(-180deg); }
//   }

//   @keyframes flip-fast {
//     0% { transform: rotateX(0); }
//     100% { transform: rotateX(-180deg); }
//   }

//   .perspective-500 {
//     perspective: 500px;
//   }

//   .origin-bottom {
//     transform-origin: bottom;
//   }

//   .animate-flip {
//     animation: flip 0.6s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite;
//     animation-delay: 0.5s;
//     backface-visibility: hidden;
//   }

//   .animate-flip-fast {
//     animation: flip-fast 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite;
//     animation-delay: 0s;
//     backface-visibility: hidden;
//   }

//   .flip-card {
//     position: relative;
//     width: 100%;
//     height: 100%;
//     text-align: center;
//     transition: transform 0.6s;
//     transform-style: preserve-3d;
//   }

//   /* Countdown Timer Styles */
//   @keyframes pulse {
//     0% { transform: scale(1); }
//     50% { transform: scale(1.05); }
//     100% { transform: scale(1); }
//   }

//   .countdown-container {
//     position: relative;
//     width: 100%;
//     max-width: 300px;
//     margin: 0 auto;
//   }

//   .countdown-ring {
//     position: relative;
//     width: 200px;
//     height: 200px;
//     margin: 0 auto;
//   }

//   .ring {
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     border-radius: 50%;
//     border: 4px solid rgba(147, 197, 253, 0.2);
//     animation: pulse 2s infinite;
//   }

//   .ring:nth-child(1) {
//     border-color: rgba(147, 197, 253, 0.2);
//   }

//   .ring:nth-child(2) {
//     border-color: rgba(147, 197, 253, 0.4);
//     transform: rotate(45deg);
//   }

//   .ring:nth-child(3) {
//     border-color: rgba(147, 197, 253, 0.6);
//     transform: rotate(90deg);
//   }

//   .countdown-items {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     display: flex;
//     gap: 1rem;
//     padding: 1rem;
//     background: rgba(255, 255, 255, 0.1);
//     backdrop-filter: blur(10px);
//     border-radius: 1rem;
//     box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
//   }

//   .countdown-item {
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     gap: 0.5rem;
//   }

//   .countdown-number {
//     font-size: 1.5rem;
//     font-weight: 700;
//     color: #3B82F6;
//   }

//   .countdown-label {
//     font-size: 0.875rem;
//     color: #6B7280;
//   }
// `;

// export default function Website() {
//   const [isVisible, setIsVisible] = useState(false);
//   const [animationStage, setAnimationStage] = useState(0);
//   // const [demoPopupOpen, setDemoPopupOpen] = useState(false);
//   const [showPlaystoreMessage, setShowPlaystoreMessage] = useState(false);
//   const [timeLeft, setTimeLeft] = useState({});

//   // State for waitlist form
//   const [email, setEmail] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     setIsVisible(true);

//     // Staggered animation timeline
//     const timeline = [
//       () => setAnimationStage(1), // Title
//       () => setAnimationStage(2), // Subtitle
//       () => setAnimationStage(3), // Buttons
//       () => setAnimationStage(4)  // Image
//     ];

//     // Execute timeline with delays
//     timeline.forEach((action, index) => {
//       setTimeout(action, 300 + (index * 200));
//     });
//   }, []);

//   // Countdown timer effect
//   useEffect(() => {
//     const calculateTimeLeft = () => {
//       // Set a fixed target date for the countdown
//       const targetDate = new Date('June 18, 2025 00:00:00').getTime();
//       const now = new Date().getTime();
//       const difference = targetDate - now;

//       if (difference > 0) {
//         return {
//           days: Math.floor(difference / (1000 * 60 * 60 * 24)).toString().padStart(2, '0'),
//           hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0'),
//           minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0'),
//           seconds: Math.floor((difference % (1000 * 60)) / 1000).toString().padStart(2, '0')
//         };
//       }
//       return { days: '00', hours: '00', minutes: '00', seconds: '00' };
//     };

//     // Initial calculation
//     setTimeLeft(calculateTimeLeft());

//     // Update countdown every second
//     const timer = setInterval(() => {
//       setTimeLeft(calculateTimeLeft());
//     }, 1000);

//     // Cleanup interval on component unmount
//     return () => clearInterval(timer);
//   }, []);

//   // Handle waitlist form submission
//   const handleWaitlistSubmit = async (e) => {
//     e.preventDefault();
//     setError("");

//     // Basic email validation
//     if (!email || !/\S+@\S+\.\S+/.test(email)) {
//       setError("Please enter a valid email address");
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       // Create waitlist data object
//       const waitlistData = {
//         email: email,
//       };

//       // Call the API to join waitlist
//       const joinWaitListRes = await api.joinWaitlist(waitlistData);
//       console.log("Join Waitlist Response:", joinWaitListRes);

//       setIsSubmitted(true);

//       // Reset form after 3 seconds
//       setTimeout(() => {
//         setIsSubmitting(false);
//         setIsSubmitted(false);
//         setEmail("");
//       }, 3000);
//     } catch (error) {
//       console.error("Error joining waitlist:", error);
//       setError("Failed to join waitlist. Please try again.");
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <Fragment>
//       <style dangerouslySetInnerHTML={{ __html: flipAnimationStyle }} />
//       {/* <div id="home" className="bg-gradient-to-br from-blue-50 via-indigo-100 to-purple-100 min-h-screen"> */}
//       <div id="home" className="min-h-screen">
//         {/* Hero Section */}
//         <div className="container mx-auto px-2 sm:px-4 md:px-8 lg:px-16 py-6 sm:py-8 md:py-12">
//           <div className="flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto">
//             <div className="md:w-1/2 text-center md:text-left mb-12 md:mb-0">
//               {/* App Logo */}
//               <div className="mb-8 bg-white p-4 rounded-full inline-block shadow-md mt-16">
//                 <div className="text-indigo-600 font-bold text-5xl">QUZY</div>
//               </div>

//               {/* Main Heading */}
//               <h1
//                 className={` text-base/8 pb-3 text-3xl sm:text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-indigo-600 to-indigo-400 bg-clip-text text-transparent transition-all duration-700 transform ${animationStage >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
//               >
//                 The most rewarding<br />way to study
//               </h1>

//               {/* Countdown Timer */}

//               {/* Subtitle */}
//               <p
//                 className={`text-base sm:text-lg text-gray-600 mb-6 max-w-2xl mx-auto transition-all duration-700 delay-100 transform ${animationStage >= 2 ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
//               >
//                 Your AI-powered study companion — quizzes, notes, planners & seamless sharing.
//               </p>

//               {/* Email signup form */}
//               <div className={`mb-8 w-full max-w-md transition-all duration-700 delay-200 transform ${animationStage >= 2 ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
//                 <div className="text-left mb-2">Join the waitlist for early access to the Quzy App</div>

//                 {isSubmitted ? (
//                   <div className="bg-green-50 border border-green-200 rounded-lg p-3 flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//                     </svg>
//                     <span className="text-green-700">Thank you! We've added you to our waitlist.</span>
//                   </div>
//                 ) : (
//                   <form onSubmit={handleWaitlistSubmit}>
//                     <div className="flex">
//                       <input
//                         type="email"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                         placeholder="Enter your email"
//                         className="flex-grow px-3 py-2 rounded-l-lg border border-gray-300 focus:ring-2 focus:ring-indigo-400 focus:outline-none"
//                         disabled={isSubmitting}
//                       />
//                       <button
//                         type="submit"
//                         disabled={isSubmitting}
//                         className={`px-4 py-2 rounded-r-lg bg-indigo-600 text-white font-semibold transition-colors duration-200 ${isSubmitting ? 'opacity-75 cursor-not-allowed' : 'hover:bg-indigo-700'}`}
//                       >
//                         {isSubmitting ? 'Submitting...' : 'Join Waitlist'}
//                       </button>
//                     </div>
//                     {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
//                   </form>
//                 )}
//               </div>

//               {/* App Features */}
//               <div className="grid md:grid-cols-4 grid-cols-2 gap-4 mt-6 mb-8">
//                 <div className="flex flex-col items-center">
//                   <div className="bg-yellow-100 p-3 rounded-lg mb-2">
//                     <FaBitcoin className="h-6 w-6 text-yellow-600" />
//                   </div>
//                   <span className="text-sm text-gray-600">AI Quizzes</span>
//                 </div>

//                 <div className="flex flex-col items-center">
//                   <div className="bg-red-100 p-3 rounded-lg mb-2">
//                     <FaCreditCard className="h-6 w-6 text-red-600" />
//                   </div>
//                   <span className="text-sm text-gray-600">Smart Notes</span>
//                 </div>

//                 <div className="flex flex-col items-center">
//                   <div className="bg-purple-100 p-3 rounded-lg mb-2">
//                     <FaGlobeAmericas className="h-6 w-6 text-purple-600" />
//                   </div>
//                   <span className="text-sm text-gray-600">Global Sharing</span>
//                 </div>

//                 <div className="flex flex-col items-center">
//                   <div className="bg-blue-100 p-3 rounded-lg mb-2">
//                     <FaExchangeAlt className="h-6 w-6 text-blue-600" />
//                   </div>
//                   <span className="text-sm text-gray-600">Seamless Sync</span>
//                 </div>
//               </div>

//               {/* Countdown and Google Play Button Container */}
//               <div className={`flex flex-col sm:flex-row items-center gap-6 mb-10 transition-all duration-700 delay-400 transform ${animationStage >= 3 ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
//                 {/* Countdown Timer */}
//                 <div className="">

//                   <div className="countdown-container mb-8">
//                     <div className="countdown-ring">
//                       <div className="ring"></div>
//                       <div className="ring"></div>
//                       <div className="ring"></div>
//                     </div>
//                     <div className="countdown-items">
//                       <div className="countdown-item">
//                         <span className="countdown-number">{timeLeft.days}</span>
//                         <span className="countdown-label">Days</span>
//                       </div>
//                       <div className="countdown-item">
//                         <span className="countdown-number">{timeLeft.hours}</span>
//                         <span className="countdown-label">Hours</span>
//                       </div>
//                       <div className="countdown-item">
//                         <span className="countdown-number">{timeLeft.minutes}</span>
//                         <span className="countdown-label">Mins</span>
//                       </div>
//                       <div className="countdown-item">
//                         <span className="countdown-number">{timeLeft.seconds}</span>
//                         <span className="countdown-label">Secs</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Google Play Button */}
//                 <div className="">
//                   <div
//                     onClick={() => {
//                       setShowPlaystoreMessage(true);
//                       setTimeout(() => setShowPlaystoreMessage(false), 3000);
//                     }}
//                     className="inline-flex items-center transition-all duration-300 transform hover:scale-105 border-2 border-transparent rounded-lg cursor-pointer relative"
//                   >
//                     <img
//                       src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
//                       alt="Get it on Google Play"
//                       className="h-16 w-auto"
//                     />
//                     {showPlaystoreMessage && (
//                       <div className="absolute -top-20 left-1 transform -translate-x-1/2 bg-indigo-400 text-white px-4 py-3 rounded-xl shadow-lg text-sm break-words animate-bounce z-20 w-56 h-20 flex items-center justify-center text-center">
//                         Beta Testing going on! Join Beta list to get the app early access.
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//             </div>

//             {/* Right Side: Mobile App Preview */}
//             <div className="mt-10 relative md:w-1/2">
//               {/* Background Circle */}
//               <div className="absolute w-[300px] h-[300px] sm:w-[400px] sm:h-[400px] bg-indigo-100 rounded-full opacity-50 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-0"></div>

//               {/* Floating Icons */}
//               <div className="absolute top-0 left-10 bg-white p-3 rounded-full shadow-md z-10 hidden sm:block">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
//                 </svg>
//               </div>

//               <div className="absolute bottom-10 left-20 bg-white p-3 rounded-full shadow-md z-10 hidden sm:block">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
//                 </svg>
//               </div>

//               <div className="absolute top-20 right-0 bg-white p-3 rounded-full shadow-md z-10 hidden sm:block">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//                 </svg>
//               </div>

//               {/* Mobile Phone Frame */}
//               <div className="relative mx-auto transform rotate-3" style={{ maxWidth: "300px" }}>
//                 {/* Floating payment screen - hidden on mobile, smaller on tablet */}
//                 <div className="absolute -right-20 -top-10 bg-gradient-to-r from-indigo-600 to-indigo-400 text-white rounded-xl p-4 shadow-lg transform rotate-6 z-20 w-48 hidden md:block lg:block xl:block">
//                   <div className="text-xs mb-2">Progress</div>
//                   <div className="font-medium mb-3">Tracking</div>
//                   <div className="space-y-2">
//                     <div className="flex justify-between items-center">
//                       <div className="w-6 h-1 bg-white rounded-full opacity-50"></div>
//                       <div>70%</div>
//                     </div>
//                     <div className="flex justify-between items-center">
//                       <div className="w-8 h-1 bg-white rounded-full opacity-50"></div>
//                       <div>10</div>
//                     </div>
//                     <div className="flex justify-between items-center">
//                       <div className="w-4 h-1 bg-white rounded-full opacity-50"></div>
//                       <div>90%</div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Main Phone */}
//                 <div className="relative bg-white rounded-[40px] shadow-xl overflow-hidden border-8 border-gray-100">
//                   {/* Phone Notch */}
//                   {/* <div className="absolute top-0 inset-x-0 h-6 bg-black rounded-b-lg w-1/3 mx-auto z-10"></div> */}

//                   {/* Phone Screen */}
//                   <div className="bg-black overflow-hidden" style={{ height: "560px" }}>
//                     <video
//                       className="h-full w-full object-cover"
//                       autoPlay
//                       loop
//                       muted
//                       playsInline
//                     >
//                       <source src={Video} type="video/mp4" />
//                       Your browser does not support the video tag.
//                     </video>
//                   </div>

//                   {/* Phone Shadow */}
//                   <div className="absolute -bottom-4 inset-x-0 h-8 bg-gradient-to-t from-gray-900 to-transparent opacity-30 rounded-[40px] mx-auto" style={{ width: "100%" }}></div>
//                 </div>

//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//     </Fragment>
//   );
// }

///////////////////////////////

import { useState, useEffect, Fragment } from "react";
import Video from "../../../assets/videoQZ.mp4";
import RequestDemo from "../../RequestDemo/RequestDemo";
// Import icons for features
import {
  FaMoneyBillWave,
  FaBitcoin,
  FaCreditCard,
  FaGlobeAmericas,
  FaExchangeAlt,
} from "react-icons/fa";
// Import API functions
import * as api from "../../../api";

// Add CSS for flip animation
const flipAnimationStyle = `
  @keyframes flip {
    0% { transform: rotateX(0); }
    100% { transform: rotateX(-180deg); }
  }
  
  @keyframes flip-fast {
    0% { transform: rotateX(0); }
    100% { transform: rotateX(-180deg); }
  }
  
  .perspective-500 {
    perspective: 500px;
  }
  
  .origin-bottom {
    transform-origin: bottom;
  }
  
  .animate-flip {
    animation: flip 0.6s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite;
    animation-delay: 0.5s;
    backface-visibility: hidden;
  }
  
  .animate-flip-fast {
    animation: flip-fast 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite;
    animation-delay: 0s;
    backface-visibility: hidden;
  }
  
  .flip-card {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.6s;
    transform-style: preserve-3d;
  }

  /* Pulse animation for call-to-action */
  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }

  .pulse-animation {
    animation: pulse 2s infinite;
  }
`;

export default function Website() {
  const [isVisible, setIsVisible] = useState(false);
  const [animationStage, setAnimationStage] = useState(0);
  const [showPlaystoreMessage, setShowPlaystoreMessage] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    // Staggered animation timeline
    const timeline = [
      () => setAnimationStage(1), // Title
      () => setAnimationStage(2), // Subtitle
      () => setAnimationStage(3), // Buttons
      () => setAnimationStage(4), // Image
    ];

    // Execute timeline with delays
    timeline.forEach((action, index) => {
      setTimeout(action, 300 + index * 200);
    });
  }, []);

  const handlePlayStoreClick = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=in.suru.quzy",
      "_blank"
    );
  };

  return (
    <Fragment>
      <style dangerouslySetInnerHTML={{ __html: flipAnimationStyle }} />
      <div id="home" className="min-h-screen">
        {/* Hero Section */}
        <div className="container mx-auto px-2 sm:px-4 md:px-8 lg:px-16 py-6 sm:py-8 md:py-12">
          <div className="flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto">
            <div className="md:w-1/2 text-center md:text-left mb-12 md:mb-0">
              {/* App Logo */}
              <div className="mb-8 bg-white p-4 rounded-full inline-block shadow-md mt-16">
                <div className="text-indigo-600 font-bold text-5xl">QUZY</div>
              </div>

              {/* Main Heading */}
              <h1
                className={`text-base/8 pb-3 text-3xl sm:text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-indigo-600 to-indigo-400 bg-clip-text text-transparent transition-all duration-700 transform ${
                  animationStage >= 1
                    ? "translate-y-0 opacity-100"
                    : "translate-y-10 opacity-0"
                }`}
              >
                The most rewarding
                <br />
                way to study
              </h1>

              {/* Subtitle */}
              <p
                className={`text-base sm:text-lg text-gray-600 mb-8 max-w-2xl mx-auto transition-all duration-700 delay-100 transform ${
                  animationStage >= 2
                    ? "translate-y-0 opacity-100"
                    : "translate-y-10 opacity-0"
                }`}
              >
                Your AI-powered study companion — quizzes, notes, planners &
                seamless sharing. Download now and start your learning journey!
              </p>

              {/* Call to Action */}
              <div
                className={`mb-6 transition-all duration-700 delay-300 transform ${
                  animationStage >= 3
                    ? "translate-y-0 opacity-100"
                    : "translate-y-10 opacity-0"
                }`}
              >
                <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-6 border border-indigo-100">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    🎉 Now Available for Open Testing!
                  </h3>
                  <div className="flex flex-col sm:flex-row gap-3 items-center">
                    <span className="text-sm text-gray-500">
                      Download the app:
                    </span>
                    <div className="pulse-animation">
                      <button
                        onClick={handlePlayStoreClick}
                        className="inline-flex items-center transition-all duration-300 transform hover:scale-105 border-2 border-transparent rounded-lg cursor-pointer"
                      >
                        <img
                          src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                          alt="Get it on Google Play"
                          className="h-14 w-auto"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* App Features */}
              <div
                className={`grid md:grid-cols-4 grid-cols-2 gap-4 mb-8 transition-all duration-700 delay-200 transform ${
                  animationStage >= 2
                    ? "translate-y-0 opacity-100"
                    : "translate-y-10 opacity-0"
                }`}
              >
                <div className="flex flex-col items-center">
                  <div className="bg-yellow-100 p-3 rounded-lg mb-2">
                    <FaBitcoin className="h-6 w-6 text-yellow-600" />
                  </div>
                  <span className="text-sm text-gray-600">AI Quizzes</span>
                </div>

                <div className="flex flex-col items-center">
                  <div className="bg-red-100 p-3 rounded-lg mb-2">
                    <FaCreditCard className="h-6 w-6 text-red-600" />
                  </div>
                  <span className="text-sm text-gray-600">Smart Notes</span>
                </div>

                <div className="flex flex-col items-center">
                  <div className="bg-purple-100 p-3 rounded-lg mb-2">
                    <FaGlobeAmericas className="h-6 w-6 text-purple-600" />
                  </div>
                  <span className="text-sm text-gray-600">Global Sharing</span>
                </div>

                <div className="flex flex-col items-center">
                  <div className="bg-blue-100 p-3 rounded-lg mb-2">
                    <FaExchangeAlt className="h-6 w-6 text-blue-600" />
                  </div>
                  <span className="text-sm text-gray-600">Seamless Sync</span>
                </div>
              </div>

              {/* Additional Features */}
              <div
                className={`transition-all duration-700 delay-400 transform ${
                  animationStage >= 3
                    ? "translate-y-0 opacity-100"
                    : "translate-y-10 opacity-0"
                }`}
              >
                <div className="flex flex-wrap justify-center md:justify-start gap-3">
                  <span className="bg-white px-4 py-2 rounded-full text-sm text-gray-600 shadow-sm border">
                    ✨ AI-Powered
                  </span>
                  <span className="bg-white px-4 py-2 rounded-full text-sm text-gray-600 shadow-sm border">
                    📱 Cross-Platform
                  </span>
                  <span className="bg-white px-4 py-2 rounded-full text-sm text-gray-600 shadow-sm border">
                    🔄 Real-time Sync
                  </span>
                  <span className="bg-white px-4 py-2 rounded-full text-sm text-gray-600 shadow-sm border">
                    🌍 Global Community
                  </span>
                </div>
              </div>
            </div>

            {/* Right Side: Mobile App Preview */}
            <div className="mt-10 relative md:w-1/2">
              {/* Background Circle */}
              <div className="absolute w-[300px] h-[300px] sm:w-[400px] sm:h-[400px] bg-indigo-100 rounded-full opacity-50 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-0"></div>

              {/* Floating Icons */}
              <div className="absolute top-0 left-10 bg-white p-3 rounded-full shadow-md z-10 hidden sm:block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-indigo-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  />
                </svg>
              </div>

              <div className="absolute bottom-10 left-20 bg-white p-3 rounded-full shadow-md z-10 hidden sm:block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-indigo-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                  />
                </svg>
              </div>

              <div className="absolute top-20 right-0 bg-white p-3 rounded-full shadow-md z-10 hidden sm:block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-indigo-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </div>

              {/* Mobile Phone Frame */}
              <div
                className="relative mx-auto transform rotate-3"
                style={{ maxWidth: "300px" }}
              >
                {/* Floating payment screen - hidden on mobile, smaller on tablet */}
                <div className="absolute -right-20 -top-10 bg-gradient-to-r from-indigo-600 to-indigo-400 text-white rounded-xl p-4 shadow-lg transform rotate-6 z-20 w-48 hidden md:block lg:block xl:block">
                  <div className="text-xs mb-2">Progress</div>
                  <div className="font-medium mb-3">Tracking</div>
                  <div className="space-y-2">
                    <div className="flex justify-between items-center">
                      <div className="w-6 h-1 bg-white rounded-full opacity-50"></div>
                      <div>70%</div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="w-8 h-1 bg-white rounded-full opacity-50"></div>
                      <div>10</div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div className="w-4 h-1 bg-white rounded-full opacity-50"></div>
                      <div>90%</div>
                    </div>
                  </div>
                </div>

                {/* Main Phone */}
                <div className="relative bg-white rounded-[40px] shadow-xl overflow-hidden border-8 border-gray-100">
                  {/* Phone Screen */}
                  <div
                    className="bg-black overflow-hidden"
                    style={{ height: "560px" }}
                  >
                    <video
                      className="h-full w-full object-cover"
                      autoPlay
                      loop
                      muted
                      playsInline
                    >
                      <source src={Video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  {/* Phone Shadow */}
                  <div
                    className="absolute -bottom-4 inset-x-0 h-8 bg-gradient-to-t from-gray-900 to-transparent opacity-30 rounded-[40px] mx-auto"
                    style={{ width: "100%" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}